module.exports = __webpack_public_path__ + "static/media/59.2717339a.mp3";